export default function getEchartOptionMeasure1(data, min) {
	let option = {
		grid: {
			x: 0,
			y: 10,
			x2: 0,
			y2: 0,
			containLabel: true
		},
		tooltip: {
			trigger: "item",
			backgroundColor: 'rgba(255, 255, 255, 0.95)',
			borderColor: "#D8E2F8",
			borderWidth: 1,
			borderRadius: 4,
			textStyle: {
				color: "#8394B9",
				fontSize: 14
			},
			confine: true,
			formatter: function (val) {

				if (val && val.data && val.data.extra) {
					let extra = JSON.parse(JSON.stringify(val.data.extra));

					// 获取单位
					let unit = extra.fType === 'oxygenSaturation' ? '%' : extra.fType === 'bodyTemperature' ? '°C' : '';

					// 获取日期
					let date = extra.date || '';

					// 获取时间点
					let time = extra.timeAvg || '';

					// 获取值(itemValueAvg：收缩压，itemValue2Avg： 舒张压)
					let tip_title = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? '收缩压' : '舒张压') : (extra.fType === 'oxygenSaturation' ? '血氧' : extra.fType === 'pulseRate' ? '脉率' : '体温');
					let tip_value = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? extra.itemValueAvg : extra.itemValue2Avg) : extra.itemValueAvg;
					let tip_value_color = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)') : (extra.itemAbnormal2Avg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)')) : (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)');
					let dotColor = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)') : (extra.itemAbnormal2Avg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)')) : (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)');

					// 顶部样式
					let topView = `
					<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(38, 38, 38, 1); line-height: 17px;'>
						<span>${date}</span>
						<span>${time}</span>
					</div>
					`

					// dot + value 样式
					let dotValView = `
					<div style="display: flex; align-items: center; margin-top: 5px;">
						<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
						<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(38, 38, 38, 1); line-height: 17px;'>${tip_title}</div>
						<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${tip_value_color}; line-height: 17px; margin-left: 5px;'>${tip_value}${unit}</div>
					</div>
					`

					if (!extra.itemRecordList || extra.itemRecordList.length == 0) {
						return topView + dotValView;
					}

					// 分割线
					let splitLine = `<div style="width: 100%; height: 1px; margin-top: 10px; margin-bottom: 10px; background: rgba(161, 210, 253, 0.3);"></div>`

					let bottomView = '';
					for (let i = 0; i < extra.itemRecordList.length; i++) {
						let item = extra.itemRecordList[i];
						let item_time = item.time || '-';
						let item_value = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? item.itemValue : item.itemValue2) : (item.itemValue);
						let item_value_color = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? (item.itemAbnormal == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)') : (item.itemAbnormal2 == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)')) : (item.itemAbnormal == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)');
						let itemView = `
						<div style="display: flex; align-items: center; margin-top: 5px;">
							<span style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(38, 38, 38, 1); line-height: 17px;'>${item_time}</span>
							<span style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${item_value_color}; line-height: 17px; margin-left: 5px;'>${item_value}${unit}</span>
						</div>
						`;
						bottomView += itemView;
					}

					return topView + dotValView + splitLine + bottomView;

				} else {
					return null;
				}
			}
		},
		xAxis: {
			type: 'category',
			data: data.xAxis_data || [],
			axisTick: {
				show: false,
			},
			axisLabel: {
				textStyle: {
					color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
					fontSize: 10
				}
			},
			axisLine: {
				lineStyle: {
					color: "rgba(144, 148, 166, 1)",
					type: "solid",
				},
			},
		},
		yAxis: {
			type: 'value',
			min: min,
			axisLine: {
				show: false,
			},
			axisLabel: { // 坐标轴刻度标签的相关设置。
				show: true,
				textStyle: {
					color: "rgba(165, 169, 188, 1)",
					fontSize: 10
				},
			},
		},
		series: data.series,
	}

	return option;
}